// removed by extract-text-webpack-plugin
module.exports = {"sider":"index__sider___1XR0D","vertical":"index__vertical___15BJ7","collapseBtn":"index__collapseBtn___iv9V2","left":"index__left___j5z5i","collapsed":"index__collapsed___YubQM","right":"index__right___3ZXBa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/Sider/index.less
// module id = 1227
// module chunks = 3